import { useEffect, useState } from "react";

const DURATION = 17 * 60 + 34; // 00:17:34, restarts automatically
const START = Date.now();

function remaining(): number {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return DURATION - (elapsed % DURATION);
}

export function useCountdown() {
  const [seconds, setSeconds] = useState(remaining);

  useEffect(() => {
    const id = window.setInterval(() => setSeconds(remaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const pad = (n: number) => String(n).padStart(2, "0");
  return {
    hours: pad(Math.floor(seconds / 3600)),
    minutes: pad(Math.floor((seconds % 3600) / 60)),
    seconds: pad(seconds % 60),
  };
}
